/**
 * Línea legible de la traza de «Mi empresa» (GEN-EKB-009): toda línea dice SOBRE QUÉ
 * se actuó (el KB o el iKu), también «Cambio». `nombreKb` resuelve el nombre de un KB
 * por id para apuntes antiguos que no lo traían en el detalle.
 */
const ACCION = {
  kb_creado: 'Alta KB',
  kb_editado: 'Cambio KB',
  kb_retirado: 'Retirada KB',
  iku_creado: 'Alta iKu',
  iku_editado: 'Cambio iKu',
  escriba_redactado: 'iKus redactados por el Escriba',
  kb_etiqueta_cambiada: 'Etiqueta KB',
  kb_etiqueta_propuesta: 'Rebaja de etiqueta propuesta',
  kb_etiqueta_confirmada: 'Rebaja de etiqueta confirmada',
  kb_etiqueta_rechazada: 'Rebaja de etiqueta rechazada',
  kb_etiqueta_sustituida: 'Propuesta de etiqueta sustituida',
  kb_permiso_concedido: 'Permiso concedido',
  kb_permiso_revocado: 'Permiso revocado',
  kb_etiqueta_cancelada: 'Propuesta de etiqueta cancelada (KB retirado)',
  area_creada: 'Alta área',
  area_renombrada: 'Área renombrada',
  area_editada: 'Cambio área',
  area_movida: 'Área movida',
  area_retirada: 'Retirada área',
  pendiente_creado: 'Pendiente creado',
  pendiente_confirmado: 'Pendiente confirmado',
  pendiente_rechazado: 'Pendiente rechazado',
  pendiente_reabierto: 'Pendiente reabierto (no se pudo ejecutar)',
  indice_reconstruido: 'Índice de búsqueda reconstruido',
  md_huerfanos_quitados: '.md huérfanos quitados del almacén de iKus',
}
const ETIQUETA = { confidencial: 'Confidencial', interna: 'Interna', publica: 'Pública' }

export function lineaTraza(t, nombreKb = () => undefined) {
  const d = t.detalle ?? {}
  const accion = ACCION[t.accion] ?? t.accion
  let sobre = ''
  let nota = ''
  if (t.accion === 'indice_reconstruido') {
    nota = `${d.proyectados ?? 0} de ${d.vigentes ?? 0} iKus vigentes proyectados`
    if (d.fallidos) nota += ` · ${d.fallidos} con fallo`
    if (d.quitados) nota += ` · ${d.quitados} sobrantes quitados`
    if (d.modelo) nota += ` · ${d.modelo}`
  } else if (t.accion === 'md_huerfanos_quitados') {
    nota = `${d.quitados ?? 0} .md de ${d.ikus ?? 0} iKus sin fila en la base`
    if (d.fallidos) nota += ` · ${d.fallidos} no se pudieron quitar`
    if (d.recientes_conservados) nota += ` · ${d.recientes_conservados} recientes conservados`
  } else if (t.accion.startsWith('pendiente_')) {
    // GEN-EKB-024: lo que Jimmy prepara y confirma quien tiene la potestad; el resumen dice qué es.
    nota = [d.resumen && `· ${d.resumen}`, d.solicitante && `(pidió ${d.solicitante})`, d.motivo && `· ${d.motivo}`].filter(Boolean).join(' ')
  } else if (t.accion === 'area_renombrada') {
    sobre = d.antes ? `«${d.antes}»` : ''
    nota = d.despues ? `→ «${d.despues}»` : ''
  } else if (t.accion.startsWith('area_')) {
    sobre = d.nombre ? `«${d.nombre}»` : ''
    if (t.accion === 'area_retirada') nota = `${d.kbs_movidos?.length ?? 0} KBs y ${d.subareas_movidas?.length ?? 0} subáreas movidos`
  } else if (t.accion === 'kb_movido_de_area') {
    // «KB «X» movido al área «Y»»: se lee sin duda qué se movió y adónde.
    const kb = d.nombre ?? nombreKb(t.contenedor_id)
    return ['KB', kb && `«${kb}»`, 'movido', d.area ? `al área «${d.area}»` : 'de área'].filter(Boolean).join(' ')
  } else if (t.accion.startsWith('iku_')) {
    sobre = d.titulo ? `«${d.titulo}»` : ''
    if (d.kb) nota = `en «${d.kb}»`
    if (t.accion === 'iku_editado' && d.version) nota = `versión ${d.version}`
  } else if (t.accion.startsWith('kb_permiso_')) {
    sobre = d.nombre ? `«${d.nombre}»` : (nombreKb(t.contenedor_id) ? `«${nombreKb(t.contenedor_id)}»` : '')
    nota = `perfil ${d.perfil}`
    if (d.para_que) nota += ` · ${d.para_que}`
  } else if (t.accion.startsWith('kb_etiqueta_')) {
    sobre = d.nombre ? `«${d.nombre}»` : (nombreKb(t.contenedor_id) ? `«${nombreKb(t.contenedor_id)}»` : '')
    nota = `${ETIQUETA[d.de] ?? d.de} → ${ETIQUETA[d.a] ?? d.a}`
    if (d.propuesto_por && t.accion !== 'kb_etiqueta_propuesta') nota += ` (propuesta de ${d.propuesto_por})`
    if (d.autoaprobada) nota += ' · autoaprobada: la misma persona propuso y confirmó'
  } else {
    const nombre = d.nombre ?? d.antes?.nombre ?? nombreKb(t.contenedor_id)
    sobre = nombre ? `«${nombre}»` : ''
    if (t.accion === 'kb_editado') {
      if (d.antes?.nombre && d.despues?.nombre) nota = `→ «${d.despues.nombre}»`
      else if (d.despues?.descripcion !== undefined) nota = '(descripción)'
      else if (d.despues?.titular !== undefined) nota = '(titular)'
    }
  }
  return [accion, sobre, nota].filter(Boolean).join(' ')
}

/** Quién consta en una línea de la traza: la persona, y si lo hizo un agente por su encargo, «Jimmy por encargo de X» (GEN-EKB-024). */
export function quienTraza(t) {
  return t.agente ? `${t.agente} por encargo de ${t.actor}` : t.actor
}
